/* tslint:disable */
/* eslint-disable */
/**
 * Melco Reporting APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportingMelcoMachineStatisticsModelsViewListItem
 */
export interface ReportingMelcoMachineStatisticsModelsViewListItem {
    /**
     * 
     * @type {string}
     * @memberof ReportingMelcoMachineStatisticsModelsViewListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportingMelcoMachineStatisticsModelsViewListItem
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportingMelcoMachineStatisticsModelsViewListItem
     */
    grouped_display?: boolean;
}

export function ReportingMelcoMachineStatisticsModelsViewListItemFromJSON(json: any): ReportingMelcoMachineStatisticsModelsViewListItem {
    return ReportingMelcoMachineStatisticsModelsViewListItemFromJSONTyped(json, false);
}

export function ReportingMelcoMachineStatisticsModelsViewListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportingMelcoMachineStatisticsModelsViewListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'grouped_display': !exists(json, 'grouped_display') ? undefined : json['grouped_display'],
    };
}

export function ReportingMelcoMachineStatisticsModelsViewListItemToJSON(value?: ReportingMelcoMachineStatisticsModelsViewListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'grouped_display': value.grouped_display,
    };
}


